import { render, staticRenderFns } from "./UpdateCommentModal.vue?vue&type=template&id=71e69c24"
import script from "./UpdateCommentModal.vue?vue&type=script&lang=js"
export * from "./UpdateCommentModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateCommentModal.vue?vue&type=style&index=0&id=71e69c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports